/* eslint-disable no-template-curly-in-string */
import R from 'ramda'
import { convertSendDarkTweetWidgetActionToFormAction } from '../widget-to-form/send-dark-tweet'

const SPEED_THREAD_STOP_WIDGET_TYPE = 'SPEED_THREAD_STOP'
const SPEED_THREAD_STOP_FORM_TYPE = 'Stop Speed Thread'

const isSpeedThreadStopWidgetType = R.propEq(
  'type',
  SPEED_THREAD_STOP_WIDGET_TYPE
)

const convertSpeedThreadStopToForm = action => {
  const success = action.success || []
  const [winReply, loseReply] = success

  const formAction = {
    ...convertSendDarkTweetWidgetActionToFormAction(winReply),
    type: SPEED_THREAD_STOP_FORM_TYPE
  }

  // Surface the target if the action has one. For older records that only carry
  // it on the win condition, derive it (guarding against a non-numeric value).
  const derivedTarget =
    winReply && winReply.condition != null
      ? Number(winReply.condition.value) / 1000
      : undefined
  const target =
    action.targetSeconds != null ? Number(action.targetSeconds) : derivedTarget

  // Treat 0 as unset to match form-to-widget, so a count-only or cleared target
  // does not surface a spurious 0 on read-back.
  if (Number.isFinite(target) && target > 0) {
    formAction.targetSeconds = target
  }

  // A win/lose split has a second, conditioned reply; surface it (and tick the
  // checkbox) for editing. A single reply with a target (count-only) has no
  // second reply, so the checkbox stays off.
  if (loseReply && loseReply.condition != null) {
    formAction.enableLoseReply = true
    formAction.loseReply = convertSendDarkTweetWidgetActionToFormAction(
      loseReply
    )
  }

  return formAction
}

export {
  isSpeedThreadStopWidgetType,
  convertSpeedThreadStopToForm,
  SPEED_THREAD_STOP_FORM_TYPE
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/stop-speed-thread.js